var map = {
	"./BioMatrix.vue": 31141,
	"./DailyInvite.vue": 88032,
	"./activity.vue": 73756,
	"./airdrop-bak.vue": 39345,
	"./airdrop.vue": 88001,
	"./airdropReward.vue": 656,
	"./avatar.vue": 37384,
	"./bitgetWallet.vue": 55724,
	"./bitgetWalletAirdrop.vue": 26714,
	"./boost.vue": 93915,
	"./city.vue": 67943,
	"./code.vue": 92354,
	"./daily.vue": 32342,
	"./earn.vue": 39537,
	"./frens.vue": 92217,
	"./index.vue": 42859,
	"./join.vue": 61183,
	"./lottery.vue": 18733,
	"./lotteryDetail.vue": 43047,
	"./lucky.vue": 40285,
	"./mine.vue": 76734,
	"./okxWallet.vue": 84128,
	"./pph.vue": 84051,
	"./rank.vue": 86233,
	"./sign.vue": 21328,
	"./squad.vue": 90263,
	"./store.vue": 94701,
	"./taskDetail.vue": 51095,
	"./wallet.vue": 62728,
	"./withdraw.vue": 70242,
	"./youtube.vue": 93746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68239;